import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

/**
 * Carte « Justificatif » — UNE seule présentation, partagée par toutes les fiches (déclaration du
 * club, encaissement, autre encaissement, ordre de paiement). Chaque écran la recopiait : la même
 * pièce finissait par s'afficher différemment d'un écran à l'autre.
 *
 * Le fichier n'est jamais embarqué : `lien` est une URL signée, à durée courte, vers le
 * file-service, ouverte dans un nouvel onglet. Sans pièce, la carte le DIT (cadre en pointillés),
 * plutôt que de laisser un vide qu'on lirait comme un écran cassé.
 */
@Component({
  selector: 'app-justificatif',
  standalone: false,
  templateUrl: './justificatif.component.html',
  // Hôte en bloc : sans ça il reste `inline`, et l'espacement `space-y-*` du parent (une
  // marge verticale) est ignoré — la carte se colle à la précédente.
  host: { class: 'block' },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class JustificatifComponent {
  /** URL signée du fichier. Absente = aucun justificatif. */
  @Input() lien: string | null | undefined;
  /** Nom du fichier affiché. */
  @Input() nom: string | null | undefined;
  /** Message d'absence (servi par l'API, ou texte par défaut). */
  @Input() message: string | null | undefined;

  /** Icône selon le format : un PDF et une image ne se reconnaissent pas au même coup d'œil. */
  get estPdf(): boolean {
    return /\.pdf($|\?)/i.test(this.nom ?? '');
  }
}
